import PropTypes from 'prop-types';
import { ResourceOrderFormActions } from 'Manifest/ResourceOrderFormActions';

export const ManifestFormActions = ({
  saveBtn,
  previous,
  saved_id,
  manifest_id,
  handleOnUpload,
  handleDeleteRof,
  handleOnViewResourceOrderForm,
  handleEditRof,
  saveConfirmOpenModal,
  savePendingManifestOpenModal,
  showSingleSaveButton = false,
  handleSaveForInUse,
  submitClick,
  viewOnly = false,
  form,
  manifestStatus,
}) => {
  return (
    <div className='gear-option-btn-wrap'>
      {!viewOnly && (
        <>
          <input
            type='button'
            className='button hide_view_manifest'
            disabled={saveBtn}
            onClick={previous}
            value='Previous'
          />
          <input
            type='button'
            className='button hide_view_manifest'
            onClick={() => window.location.reload()}
            disabled={saveBtn}
            value='Cancel'
          />
          {(saved_id || manifest_id) && (
            <>
              <input
                type='submit'
                id='to_view_final_print'
                disabled={saveBtn}
                className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                name='print'
                onClick={submitClick}
                value='Print Manifest'
              />
              {manifestStatus !== 'pending' && (
                <input
                  type='submit'
                  id='to_view_final_email'
                  name='email'
                  disabled={saveBtn}
                  className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                  onClick={submitClick}
                  value='Email Manifest'
                />
              )}
            </>
          )}
          <ResourceOrderFormActions
            enableViewButton={form.resource_order_form}
            handleOnUpload={handleOnUpload}
            handleDeleteRof={handleDeleteRof}
            handleOnView={handleOnViewResourceOrderForm}
            handleOnEdit={handleEditRof}
            disabled={saveBtn}
            viewOnly={viewOnly}
          />
          {showSingleSaveButton ? (
            <input
              type='button'
              disabled={saveBtn}
              className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
              name='save'
              onClick={handleSaveForInUse}
              value='Save'
            />
          ) : (
            <>
              <input
                type='button'
                disabled={saveBtn}
                className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                name='save'
                onClick={(e) => {
                  e.preventDefault();
                  if (saveConfirmOpenModal) {
                    saveConfirmOpenModal(e);
                  }
                }}
                value='Save and Commit'
              />
              <input
                type='button'
                disabled={saveBtn}
                className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                name='savePending'
                onClick={(e) => {
                  e.preventDefault();
                  if (savePendingManifestOpenModal) {
                    savePendingManifestOpenModal(e);
                  }
                }}
                value='Save Pending Manifest'
              />
            </>
          )}
          {saveBtn && (
            <img
              className='login_loader'
              alt='loader'
              src='data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=='
            />
          )}
        </>
      )}
    </div>
  );
};

ManifestFormActions.propTypes = {
  saveBtn: PropTypes.bool.isRequired,
  previous: PropTypes.func.isRequired,
  saved_id: PropTypes.string,
  manifest_id: PropTypes.string,
  handleOnUpload: PropTypes.func.isRequired,
  handleDeleteRof: PropTypes.func.isRequired,
  handleOnViewResourceOrderForm: PropTypes.func.isRequired,
  handleEditRof: PropTypes.func.isRequired,
  saveConfirmOpenModal: PropTypes.func.isRequired,
  savePendingManifestOpenModal: PropTypes.func,
  showSingleSaveButton: PropTypes.bool,
  handleSaveForInUse: PropTypes.func,
  submitClick: PropTypes.func.isRequired,
  viewOnly: PropTypes.bool,
  form: PropTypes.object.isRequired,
  manifestStatus: PropTypes.string,
};
